<template>
  <v-container style="padding:0px !important;">
    <activities 
      :isDesktop="!isMobile"
    />
  </v-container>
</template>

<script>
import Activities from './Activities'

export default {
  name: 'Home',
  components: {
    Activities
  },
  data () {
    return {
    }
  },
  computed: {
    isMobile () {
      if (navigator.userAgent.match(/iPad/i) != null) return false
      if (navigator.userAgent.match(/Mobi/)) return true
      if ('screen' in window && window.screen.width <= 800 && window.screen.height <= 600) return true

      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
      if (connection && connection.type === 'cellular') return true

      return false
    },
    isIpad () {
      return navigator.userAgent.match(/iPad/i) != null
    },
  }
}
</script>
